import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getOrderList({
    courier_id,
    cursor,
    end_date,
    limit,
    q,
    sort_by,
    start_date,
    status,
    warehouse_id,
  }) {
    const params = {
      courier_id,
      cursor,
      end_date,
      limit,
      q,
      sort_by,
      start_date,
      status,
      warehouse_id,
    };
    const url = '/order_collections';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getOrderReport(
    status = '',
    q,
    startDate = '',
    endDate = '',
    sortBy = '',
    courier = '',
    page,
    limit
  ) {
    const params = {
      courier_id: courier,
      cursor: page,
      end_date: endDate,
      limit,
      q,
      sort_by: sortBy,
      start_date: startDate,
      status,
    };
    const url = '/order_collections/order_reports';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getCustomerOrders(page, limit, userId) {
    const params = {
      cursor: page,
      limit,
      user_id: userId,
    };
    const url = '/orders';
    return api.get(url, { params });
  },
  confirmShipment(id, trackCode) {
    return api.post(`/orders/${id}/confirm_shipment`, {
      tracking_code: trackCode,
    });
  },
  updateShipment(id, trackCode) {
    return api.post(`/orders/${id}/update_shipment`, {
      tracking_code: trackCode,
    });
  },
  getCourierList() {
    return api.get(`/orders/couriers?status=active&`);
  },
  processOrder(id) {
    return api.post(`/order_collections/${id}/process_order`);
  },
  processPackageOrder(id) {
    return api.post(`/orders/${id}/process_order`);
  },
  rejectOrder(id, message) {
    return api.post(`/order_collections/${id}/reject_order`, { message });
  },
  rejectOrderPackage(id, message) {
    return api.post(`/orders/${id}/reject_order`, { message });
  },
  confirmDelivery(id) {
    return api.post(`/orders/${id}/confirm_delivery`);
  },
  getOrderDetail(id) {
    return api.get(`/orders/${id}/all`);
  },
  getOrderCollection(id) {
    return api.get(`/order_collections/${id}/detail`);
  },
  getOrderActivity(id) {
    return api.get(`/orders/${id}/activities`);
  },
  getOrderCollectionActivity(id) {
    return api.get(`/order_collections/${id}/activities`);
  },
  getOrderTracking(id) {
    return api.get(`/orders/${id}/track_shipment`);
  },
  getOrderShippingLabel(id) {
    return api.get(`/orders/${id}/shipping_label`);
  },
  findDriverGosend(id) {
    return api.post(`/orders/${id}/delivery_order`);
  },
  shipOrder(id) {
    return api.post(`/orders/${id}/ship_order`);
  },
  completeOrder(id) {
    return api.post(`/orders/${id}/complete`);
  },
  acceptOfflineOrder(id, payload) {
    return api.post(`/order_collections/${id}/process_offline_order`, payload);
  },

  sendToPickUp(id) {
    return api.post(`/orders/${id}/send_to_pickup`);
  },
  getInvoiceOrder(id) {
    return api.get(`/orders/${id}/invoice_label`);
  },
  getInvoiceOrderCollection(id) {
    return api.get(`/order_collections/${id}/invoice_label`);
  },
  handoverPickup(id) {
    return api.post(`/orders/${id}/handover_pickup`);
  },
  updateOrderInfo(id, payload) {
    return api.post(`/orders/${id}/update_order_info`, payload);
  },
};
